<template>
  <fieldset :class="$style.fieldset">
    <slot />
  </fieldset>
</template>

<script>
export default {
  name: 'BaseFieldset',
}
</script>

<style lang="scss" module>
.fieldset:not(:first-child) {
  margin-top: 3.75rem;
}

.fieldset {
  margin: 0;
  padding: 0;

  border: none;

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;

    user-select: none;

    pointer-events: none;

    fieldset {
      &[disabled] {
        opacity: 1 !important;
      }
    }
  }

  &:empty {
    margin: 0 !important;
  }

  > *:last-child {
    margin-bottom: 0 !important;
  }
}
</style>
